import * as Yup from "yup";

export default function configurarValidaciones(){
Yup.addMethod(Yup.string, 'primeraLetraMayuscula', function(){
    return this.test('primera-letra-mayuscula', 'La primera letra debe ser mayúscula',
    function(valor){
        if(valor && valor.length>0){
            const primeraLetra= valor.substring(0,1);
            return primeraLetra === primeraLetra.toUpperCase();
        }
        return true;
    })
})

Yup.addMethod(Yup.string, 'email', function(){
    return this.test('email', 'Correo electrónico no válido',
    function(valor){
        if(valor && valor.length>0){
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(valor) || valor.lastIndexOf("@inegi.org.mx")===-1){
                return false;
            }
        }
        return true;
    })
})
Yup.addMethod(Yup.string, 'letras', function(){
    return this.test('letras', 'Solo deben ser letras',
    function(valor){
        if(valor && valor.length>0){
            let regex = new RegExp("^[a-zA-Z ]+$");
            if (!regex.test(valor)) {
                return false;
            }
        }
        return true;
    })
})
Yup.addMethod(Yup.string, 'numeros', function(){
    return this.test('numeros', 'Solo deben ser numeros',
    function(valor){
        if(valor && valor.length>0){
            let regex = new RegExp("^[0-9]+$");
            if (!regex.test(valor)) {
                return false;
            }
        }
        return true;
    })
})
Yup.addMethod(Yup.string, 'select', function(){
    return this.test('select', 'Debe seleccionar una opción',
    function(valor){
        if(valor && valor.length>0){
            if (valor==="Seleccionar") {
                return false;
            }
        }
        return true;
    })
})
}